import { render } from "./PersianDatePicker.vue?vue&type=template&id=7c8ca63f&scoped=true"
import script from "./PersianDatePicker.vue?vue&type=script&lang=js"
export * from "./PersianDatePicker.vue?vue&type=script&lang=js"

import "./PersianDatePicker.vue?vue&type=style&index=0&id=7c8ca63f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8ca63f"]])

export default __exports__